/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, OnDestroy, AfterViewChecked, AfterViewInit } from '@angular/core';
import { TicketTab, EventMappingType, OddsValidationMode, SiteViewConfiguration, PlatformHeadrId, SuperbetMessageType } from 'src/app/models/enums';
import { TicketService } from 'src/app/services/ticket.service';
import { ITicketItemGroup } from 'src/app/models/ticket/ticketItemGroup.interface';
import { Subscription } from 'rxjs';
import { ITicketOrderingItem } from 'src/app/models/ticket/ticketOrderingItem';
import { ITicketItemIdentifier } from 'src/app/models/ticket/ticketItemIdentfier.interface';
import { ITicketItem } from 'src/app/models/ticket/ticketItem.inerface';
import { IOddContainer } from './oddContainer.interface';
import { CacheChangesService } from 'src/app/services/cacheChanges.service';
import { ICacheChanges } from 'src/app/models/cacheChanges/cacheChanges.interface';
import { ChangesUpdaterService } from 'src/app/services/changesUpdaterService.service';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { EventsService } from 'src/app/services/events.service';
import { EventVM } from 'src/app/models/event/event';
import { UtilityService } from 'src/app/services/util/utility.service';
import { ModelMapperService } from 'src/app/services/util/model.mapper.service';
import { UserService } from 'src/app/services/user.service';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { ITicketData } from 'src/app/models/ticket/ticketData.interface';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { IPlayedTicket } from 'src/app/models/ticket/playedTicket';
import { DeployParams } from 'src/app/deployParams';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { LoaderService } from 'src/app/services/loader.service';
// import { storage } from 'firebase';
import { StorageService } from 'src/app/services/util/storage.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { IAffiliate } from 'src/app/ticket-manager/models/user/affiliate.interface';
import { AffiliateRole } from 'src/app/ticket-manager/models/util/tmEnums';
import { TicketManagerTicketService } from 'src/app/ticket-manager/services/ticket-manager-ticket.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.less']
})


export class TicketComponent implements OnInit, OnDestroy, AfterViewInit {

  public dynamicTranslations = DynamicTranslations;
  constantValues = ConstantValues;
  private updatedCacheTime = 0;

  TicketTabENUM = TicketTab;
  selectedTab: TicketTab = TicketTab.Ticket;
  public isBankersChanged = false;
  COMBI = 0;
  SYSTEM = 1;
  SINGLE = 2;
  selectedBetTypeIndex = this.COMBI;
  // Holds event Ids.
  // events: IEventGroup[] = [];
  // ticketItems: ITicketItem[] = [];
  // Holds map of event and its outcomes in the ticket.
  // itemsInTicket: { [eventId: number]: IEventGroup } = {};
  // Holds odds for each event. In case of multiple outcomes for single event
  // the value is the max odds for all outcome combinations.
  oddsMap: { [eventId: number]: number } = {};
  // Holds odds for each event. In case of multiple outcomes for single event
  // the value is the MIN odds for all outcome combinations.
  minOddsMap: { [eventId: number]: number } = {};
  orderingForTicketItemGroups: ITicketOrderingItem[] = [];
  isTicketOnline: boolean;
  ticketChanged = true;
  isOddChanged = false;
  showBankers = true;

  selectedEventsInCombinations?: number[] = null;

  public eventsInBankersGroup: number[] = [];
  public isUserLoggedIn = false;

  ticketItemGroups: { [eventId: number]: ITicketItemGroup };
  oddsValidationMode: OddsValidationMode = OddsValidationMode.AcceptAllOdds;
  oddsValidationModeEnum = OddsValidationMode;
  today: Date = new Date();

  private subscription: Subscription = new Subscription();
  languageCulture: string;

  isMobileView: boolean;
  public viewConfigurations = ViewConfigurations;

  // protected language: string;
  isSearchValid = true;
  searchMessage: string;
  checkTicketId = '';
  checkTicketPin = '';
  showTicket = false;
  isScanActive = false;
  ticketMainWrap: any;
  showTicketDetails: boolean;
  superBetMsgType: SuperbetMessageType = SuperbetMessageType.NONE;
  loggedAffiliate: IAffiliate;
  affiliateRoleEnum = AffiliateRole;
  eventMappingTypeEnum = EventMappingType;

  public totalWinings = 0;
  public numberOfBets = 0;
  public totalStake = 0;
  public wagerPerBet = 0;
  public minWinings = 0;
  public totalOdd = 0;
  public minOdd = 0;
  public possibleWin = 0;
  public bonus = 0;
  public bonusPercent = 0;
  public payin = 0;
  public taxBeforeStake = 0;
  public taxOnWinning = 0;
  public possibleWinWithoutTax = 0;
  public possibleMinPayout = 0;
  public taxOnMinWinnings = 0;
  public windowWidth = 0;

  constructor(
    protected loaderService: LoaderService,
    protected ticketService: TicketService,
    protected cacheChangesService: CacheChangesService,
    protected changesUpdater: ChangesUpdaterService,
    protected eventsService: EventsService,
    protected modelMapper: ModelMapperService,
    protected utilityService: UtilityService,
    protected queryParamsService: QueryParamsService,
    protected userService: UserService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected storageService: StorageService,
    protected authentificationService: AuthenticationService,
    protected ticketServiceTM: TicketManagerTicketService) {
    if (this.viewConfigurations.showOnlySystemTicket) {
      this.selectedBetTypeIndex = this.SYSTEM;
    }
    this.ticketItemGroups = this.ticketService.ticketItemGroups;
    this.subscription.add(this.ticketService.ticketItemAddedRemoved$.subscribe((source) => {
      if (source.isAdded) {
        this.addTicketItemOrdering(source);
        this.cacheChangesService.subscribeForEventInTicketChanges(source.eventId, source.isLive);
        this.onTiketChange(TicketTab.Ticket);
      } else {
        this.removeTicketItemFromOrdering(source);
        this.cacheChangesService.unsubscribeForEventInTicketChanges(source.eventId, source.isLive);
      }
      const superBetEventsOrdering = this.orderingForTicketItemGroups.filter(o => this.ticketItemGroups[o.eventId].mappingType === EventMappingType.SuperBetEvent);
      const nonSuperBetEventsOrdering = this.orderingForTicketItemGroups.filter(o => this.ticketItemGroups[o.eventId].mappingType !== EventMappingType.SuperBetEvent);
      if (superBetEventsOrdering.length > 0) {
        if (nonSuperBetEventsOrdering.filter(sbo => sbo.outcomeIds.filter(oid => this.ticketItemGroups[sbo.eventId].ticketItems[oid].odd >= ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD).length > 0).length >= ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS) {
          this.superBetMsgType = SuperbetMessageType.NONE;
        } else {
          this.superBetMsgType = SuperbetMessageType.MIN_NON_SB_ODD_AND_COUNT;
        }
        // if (nonSuperBetEventsOrdering.filter(sbo => sbo.outcomeIds.filter(oid => this.ticketItemGroups[sbo.eventId].ticketItems[oid].odd < ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD).length > 0).length > 0) {
        //   this.superBetMsgType = SuperbetMessageType.MIN_NON_SB_ODD;
        // } else if (nonSuperBetEventsOrdering.length < ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS) {
        //   this.superBetMsgType = SuperbetMessageType.MIN_NON_SB_COUNT;
        // } else {
        //   this.superBetMsgType = SuperbetMessageType.NONE;
        // }
      } else {
        this.superBetMsgType = SuperbetMessageType.NONE;
      }
    }));

    this.subscription.add(this.ticketService.openTicket$.subscribe((played) => this.toggleTicket()));
    this.subscription.add(this.ticketService.openMyTicket$.subscribe((x) => this.openMyTickets()));

    this.subscription.add(this.cacheChangesService.cacheUpdatedPM$.subscribe((c) => this.updateticketItemGroups(c, false)));
    this.subscription.add(this.cacheChangesService.cacheUpdatedLive$.subscribe((c) => this.updateticketItemGroups(c, true)));
    this.subscription.add(this.ticketService.ticketPlayed$.subscribe(x => {
      if (this.isMobileView) {
        this.toggleTicket();
      }
    }));
    this.subscription.add(this.ticketService.ticketDataUpdated$.subscribe(() => {
      setTimeout(() => {
        this.totalWinings = this.ticketService.ticketData.totalWinings;
        this.numberOfBets = this.ticketService.ticketData.numberOfBets;
        this.totalStake = this.ticketService.ticketData.totalStake;
        this.wagerPerBet = this.ticketService.ticketData.wagerPerBet;
        this.minWinings = this.ticketService.ticketData.minWinings;
        this.totalOdd = this.ticketService.ticketData.totalOdd;
        this.minOdd = this.ticketService.ticketData.minOdd;
        this.possibleWin = this.ticketService.ticketData.possibleWin;
        this.bonus = this.ticketService.ticketData.bonus;
        this.bonusPercent = this.ticketService.ticketData.bonusPercent;
        this.payin = this.ticketService.ticketData.payin;
        this.taxBeforeStake = this.ticketService.ticketData.taxBeforeStake;
        this.taxOnWinning = this.ticketService.ticketData.taxOnWinings;
        this.possibleWinWithoutTax = this.ticketService.ticketData.possibleWinWithoutTax;
        this.possibleMinPayout = this.ticketService.ticketData.possibleMinPayout;
        this.taxOnMinWinnings = this.ticketService.ticketData.taxOnMinWinning;

      });
    }));

    if (this.userService.user.userSBToken) {
      this.isUserLoggedIn = true;
    }

    if (this.authentificationService.loggedAffiliate && storageService.affiliateJwtToken) {
      this.isUserLoggedIn = true;
    }

    this.subscription.add(this.userService.userLoggedInOut$.subscribe((x) => {
      this.isUserLoggedIn = x;
    }));

    this.subscription.add(this.authentificationService.loggedAffiliateChangedSource$.subscribe(() => {
      this.loggedAffiliate = this.authentificationService.loggedAffiliate;
      if (this.authentificationService.loggedAffiliate && storageService.affiliateJwtToken) {
        this.isUserLoggedIn = true;
      } else {
        this.isUserLoggedIn = false;
      }
    }));
    this.loggedAffiliate = this.authentificationService.loggedAffiliate;
    const currentUser = this.userService.user;

    this.languageCulture = LocaleHelper.cultureName[storageService.language];
    this.isMobileView = utilityService.mobileView;

    this.subscription.add(ticketService.fastTicketOrStorageLoaded$.subscribe(data => {
      if (ViewConfigurations.showOnlySystemTicket || (data.systemGroupEventIds && data.systemGroupEventIds.length > 0)) {
        this.selectedBetTypeIndex = this.SYSTEM;
      } else if (data.fixedGroupEventIds && data.fixedGroupEventIds.length === 1) {
        this.selectedBetTypeIndex = this.SINGLE;
      } else {
        this.selectedBetTypeIndex = this.COMBI;
      }
      if (data.systemGroupEventIds && data.systemGroupEventIds.length > 0 && data.fixedGroupEventIds && data.fixedGroupEventIds.length > 0) {
        for (const eId of data.fixedGroupEventIds) {
          if (this.ticketItemGroups[eId]) {
            this.ticketItemGroups[eId].isInBankersGroup = true;
          }
        }
        this.eventsInBankersGroup = data.fixedGroupEventIds;
        this.isBankersChanged = !this.isBankersChanged;
        this.notifyTicketChange();
      }

      if (data.selectedEventsInCombinations && data.selectedEventsInCombinations.length > 0) {
        setTimeout(() => {
          this.selectedEventsInCombinations = data.selectedEventsInCombinations;
        }, 100);
      }
    }));

  }

  // setTotalWinings(totalWinings: number) {
  //   this.totalWinings = totalWinings;
  // }

  ngOnInit(): void {
    if (this.viewConfigurations.useSavedOddsValidationMode) {
      this.oddsValidationMode = this.storageService.oddsValidationMode ? this.storageService.oddsValidationMode : OddsValidationMode.AcceptAllOdds;
    }
    this.subscription.add(this.ticketService.oddsValidationChanged$.subscribe((o) => {
      this.oddsValidationMode = o;
      if (this.viewConfigurations.useSavedOddsValidationMode) {
        this.storageService.oddsValidationMode = o;
      }
    }));

    if (this.queryParamsService.queryParameters && this.queryParamsService.queryParameters.ticketId && this.queryParamsService.queryParameters.ticketPin) {
      if (this.isMobileView) {
        this.selectedTab = TicketTab.FindTicket;
      }
      this.checkTicketId = this.queryParamsService.queryParameters.ticketId.replace(/[^\dA-Z]/g, '').replace(/(.{3})/g, '$1 ').trim();
      this.checkTicketPin = this.queryParamsService.queryParameters.ticketPin;
      this.checkTicket();
    }

    if (Object.keys(this.ticketService.ticketItemGroups).length > 0 && this.orderingForTicketItemGroups.length === 0) {
      this.ticketService.addExistingItemsToTicket();
    }

    if (this.viewConfigurations.showOnlySystemTicket) {
      this.selectedBetTypeIndex = this.SYSTEM;
    }

    if (this.ticketService.ticketDetailsToAddOnTicketCreate) {
      this.ticketService.reAddItemsToTicket(
        this.ticketService.ticketDetailsToAddOnTicketCreate.ticketItemGroups,
        this.ticketService.ticketDetailsToAddOnTicketCreate.outcomesWithPlayableStatuses,
        this.ticketService.ticketDetailsToAddOnTicketCreate.totalStake,
        this.ticketService.ticketDetailsToAddOnTicketCreate.fixedGroupEventIds,
        this.ticketService.ticketDetailsToAddOnTicketCreate.systemGroupEventIds,
        this.ticketService.ticketDetailsToAddOnTicketCreate.selectedEventsInCombinations);

      this.ticketService.ticketDetailsToAddOnTicketCreate = null;
    }

    this.windowWidth = innerWidth;
  }


  private addTicketItemOrdering(identifier: ITicketItemIdentifier) {
    const groupIndex = this.orderingForTicketItemGroups.findIndex(o => o.eventId === identifier.eventId);
    let outcomeIds: number[] = [];
    if (groupIndex === -1) {
      this.orderingForTicketItemGroups.push({ eventId: identifier.eventId, outcomeIds });
      this.oddsMap[identifier.eventId] = this.ticketItemGroups[identifier.eventId].ticketItems[identifier.betOutcomeId].odd;
      this.minOddsMap[identifier.eventId] = this.ticketItemGroups[identifier.eventId].ticketItems[identifier.betOutcomeId].odd;
    } else {
      const eventOdds: IOddContainer = this.ticketService.getMInAndMaxOddForEvent(
        identifier.eventId,
        Object.entries(this.ticketItemGroups[identifier.eventId].ticketItems).map(([k, ti]) => ({ outcomeId: ti.betOutcomeId, outcomeTypeId: ti.betTypeOutcomeId })),
        this.ticketItemGroups
      );

      this.oddsMap[identifier.eventId] = eventOdds.maxOdd;
      this.minOddsMap[identifier.eventId] = eventOdds.minOdd;
      outcomeIds = this.orderingForTicketItemGroups[groupIndex].outcomeIds;
    }

    if (this.viewConfigurations.showNumberOfHitsForTicketSystem) {

      this.ticketService.minOddsSysEvIdsByOddLowToHighWithoutBankers = this.ticketService.createminOddsSysEvIdsByOddLowToHiWithoutBankers(this.ticketItemGroups, this.eventsInBankersGroup, this.minOddsMap);
      this.ticketService.maxOddsSysEvIdsByOddHighToLowWithoutBankers = this.ticketService.createmaxOddsSysEvIdsByOddHiToLowWithoutBankers(this.ticketItemGroups, this.eventsInBankersGroup, this.oddsMap);
    }

    // added to forbid multiple events in ticket single
    if (this.orderingForTicketItemGroups.length === 1 && !this.viewConfigurations.showOnlySystemTicket) {
      if (!this.isMobileView) {
        this.selectedBetTypeIndex = this.SINGLE;
      } else {
        this.selectedBetTypeIndex = this.COMBI;
      }
    } else if (this.selectedBetTypeIndex === this.SINGLE) {
      this.selectedBetTypeIndex = this.COMBI;
    }

    this.notifyTicketChange();
    this.setIsTicketOnline();
    outcomeIds.push(identifier.betOutcomeId);
  }

  notifyPlaceBetClicked() {
    // if (ViewConfigurations.useMobileViewWithTopMenu) {
    //   this.loaderService.showHideLoader(true);
    // }

    this.showTicketDetails = false;

    this.ticketService.notifyPlaceBetClicked();
  }

  private removeTicketItemFromOrdering(identifier: ITicketItemIdentifier) {
    const groupIndex = this.orderingForTicketItemGroups.findIndex(o => o.eventId === identifier.eventId);
    if (groupIndex === -1) {
      return;
    }

    const tiIndex = this.orderingForTicketItemGroups[groupIndex].outcomeIds.indexOf(identifier.betOutcomeId);
    if (tiIndex === -1) {
      return;
    }

    this.orderingForTicketItemGroups[groupIndex].outcomeIds.splice(tiIndex, 1);

    if (this.orderingForTicketItemGroups[groupIndex].outcomeIds.length === 0) {
      this.orderingForTicketItemGroups.splice(groupIndex, 1);
      delete this.oddsMap[identifier.eventId];
      delete this.minOddsMap[identifier.eventId];
      const index = this.eventsInBankersGroup.indexOf(identifier.eventId);
      if (index !== -1) {
        this.eventsInBankersGroup.splice(index, 1);
      }
    } else {
      const eventOdds: IOddContainer = this.ticketService.getMInAndMaxOddForEvent(
        identifier.eventId,
        Object.entries(this.ticketItemGroups[identifier.eventId].ticketItems).map(([k, ti]) => ({ outcomeId: ti.betOutcomeId, outcomeTypeId: ti.betTypeOutcomeId })),
        this.ticketItemGroups
      );
      this.oddsMap[identifier.eventId] = eventOdds.maxOdd;
      this.minOddsMap[identifier.eventId] = eventOdds.minOdd;
    }

    if (this.viewConfigurations.showNumberOfHitsForTicketSystem) {
      this.ticketService.minOddsSysEvIdsByOddLowToHighWithoutBankers = this.ticketService.createminOddsSysEvIdsByOddLowToHiWithoutBankers(this.ticketItemGroups, this.eventsInBankersGroup, this.minOddsMap);
      this.ticketService.maxOddsSysEvIdsByOddHighToLowWithoutBankers = this.ticketService.createmaxOddsSysEvIdsByOddHiToLowWithoutBankers(this.ticketItemGroups, this.eventsInBankersGroup, this.oddsMap);
    }
    // added to forbid multiple events in ticket single
    if ((this.orderingForTicketItemGroups.length === 0 || this.orderingForTicketItemGroups.length === 1)
      && !this.viewConfigurations.showOnlySystemTicket) {
      if (!this.isMobileView) {
        this.selectedBetTypeIndex = this.SINGLE;
      } else {
        this.selectedBetTypeIndex = this.COMBI;
      }
    }
    this.notifyTicketChange(false);
    // this.notifyTicketChange(false, isLastOutcomeInEventOrSingleRemove);
  }

  setIsTicketOnline() {
    this.isTicketOnline = this.ticketService.isTicketOnline(this.ticketItemGroups);
  }

  onBankersEnabledChanged(bankersEnabled: boolean) {
    this.showBankers = bankersEnabled;
    this.notifyTicketChange();
  }

  expandEventOfTIGroup(group: ITicketItemGroup) {
    if (!group.isEventPlayable) {
      return;
    }
    if (!this.isMobileView) {
      this.eventsService.expandEvent(this.modelMapper.mapEventFromTicketItemGroup(group, this.languageCulture));

    }
  }

  bankerChanged(group: ITicketItemGroup) {
    this.isBankersChanged = !this.isBankersChanged;
    const index = this.eventsInBankersGroup.findIndex(evId => evId === group.eventId);
    if (group.isInBankersGroup) {
      if (index === -1) {
        this.eventsInBankersGroup.push(group.eventId);
        if (this.viewConfigurations.showNumberOfHitsForTicketSystem) {
          this.ticketService.minOddsSysEvIdsByOddLowToHighWithoutBankers = this.ticketService.createminOddsSysEvIdsByOddLowToHiWithoutBankers(this.ticketItemGroups, this.eventsInBankersGroup, this.minOddsMap);
          this.ticketService.maxOddsSysEvIdsByOddHighToLowWithoutBankers = this.ticketService.createmaxOddsSysEvIdsByOddHiToLowWithoutBankers(this.ticketItemGroups, this.eventsInBankersGroup, this.oddsMap);
        }

      }
    } else {
      if (index !== -1) {
        this.eventsInBankersGroup.splice(index, 1);
        if (this.viewConfigurations.showNumberOfHitsForTicketSystem) {
          this.ticketService.minOddsSysEvIdsByOddLowToHighWithoutBankers = this.ticketService.createminOddsSysEvIdsByOddLowToHiWithoutBankers(this.ticketItemGroups, this.eventsInBankersGroup, this.minOddsMap);
          this.ticketService.maxOddsSysEvIdsByOddHighToLowWithoutBankers = this.ticketService.createmaxOddsSysEvIdsByOddHiToLowWithoutBankers(this.ticketItemGroups, this.eventsInBankersGroup, this.oddsMap);
        }
      }
    }
    this.storageService.ticketItemGroups = this.ticketItemGroups;
    this.notifyTicketChange();
  }

  notifyTicketChange(isOddChanged: boolean = false, isLastOutcomeInEventOrSingleRemove: boolean = true) {
    // added because fast changes wont be detected  by ui and will not be passed to chiled as input changed
    setTimeout(() => {
      if (isLastOutcomeInEventOrSingleRemove) {
        this.ticketChanged = !this.ticketChanged;
      }
      this.isOddChanged = isOddChanged;
    });
  }

  removeTicketItem(group: ITicketItemGroup, item: ITicketItem) {
    this.ticketService.removeTicketItem(group, item);
    this.setIsTicketOnline();
  }

  removeTicketItemGroup(group: ITicketItemGroup) {
    this.ticketService.removeTicketItemGroup(group);
    this.setIsTicketOnline();
  }

  removeAllTicketItems() {
    this.ticketService.removeAllTicketItems();
    this.setIsTicketOnline();
  }

  removeOfflineTicketItems() {
    const ticketItemsWithEvIdsToRemove: { eventId: number; ticketItem: ITicketItem }[] = [];
    for (const orderingGroup of this.orderingForTicketItemGroups) {
      if (this.ticketItemGroups[orderingGroup.eventId]) {
        const ticketItemGroup = this.ticketItemGroups[orderingGroup.eventId];
        for (const oid of orderingGroup.outcomeIds) {
          if (ticketItemGroup.ticketItems[oid] &&
            !(ticketItemGroup.ticketItems[oid].isBetOutcomePlayable
              && ticketItemGroup.ticketItems[oid].isBetPlayable
              && ticketItemGroup.isEventPlayable
              && ticketItemGroup.ticketItems[oid].odd > 1)) {
            ticketItemsWithEvIdsToRemove.push({ eventId: ticketItemGroup.eventId, ticketItem: ticketItemGroup.ticketItems[oid] });
          }
        }
      }
    }

    for (const tiWithEvId of ticketItemsWithEvIdsToRemove) {
      this.removeTicketItem(this.ticketItemGroups[tiWithEvId.eventId], tiWithEvId.ticketItem);
    }
  }

  onTiketChange(tabType: TicketTab) {
    this.selectedTab = tabType;
    if ((tabType === TicketTab.MyTickets || tabType === TicketTab.FindTicket) && this.isMobileView) {
      setTimeout(() => {
        this.validateTicketIdInput();
      }, 300);
    }
  }

  onTabChange(event) {
    //  added to forbid multiple events in ticket single
    if (event.index === this.SINGLE && this.orderingForTicketItemGroups.length > 1) {
      return;
    }

    this.selectedBetTypeIndex = event.index;
  }

  setIsSearchValid(key: number) {
    this.searchMessage = '';
    this.isSearchValid = true;

    if (key !== 13 && key) {
      return;
    }

    const ticketId = this.checkTicketId.replace(/[^\dA-Z]/g, '').trim();

    if (ticketId.length !== 20 && (ticketId.length < ConstantValues.MIN_TICKET_ID_SIZE || ticketId.length > ConstantValues.MAX_TICKET_ID_SIZE)) {
      this.searchMessage = DynamicTranslations.findTicket_ticketIdShortMessage;
      this.isSearchValid = false;
      return;
    }

    if (this.checkTicketPin.length !== 4) {
      if((ticketId.length - (4 - this.checkTicketPin.length))< ConstantValues.MIN_TICKET_ID_SIZE){
        this.searchMessage = DynamicTranslations.findTicket_ticketPinShortMessage;
        this.isSearchValid = false;
        return;
      }else{
        const pinStart = ticketId.slice(this.checkTicketPin.length - 4);
        this.checkTicketId = this.checkTicketId.slice(0, this.checkTicketPin.length - 4);
        this.checkTicketPin = pinStart + this.checkTicketPin;
      }
    }

    if (key) {
      this.checkTicket();
    }
  }

  checkTicket(scanned: boolean = false) {
    this.setIsSearchValid(null);

    if (!this.isSearchValid) {
      return;
    }

    const ticketId = this.checkTicketId.replace(/[^\dA-Z]/g, '').trim();

    if (this.loggedAffiliate) {
      this.ticketServiceTM.getExternalTicketWithPlatformTicketStatus(ticketId, this.checkTicketPin).subscribe(ticket => this.openPlayedTicketDetails(ticket, scanned));
    } else {
      this.ticketService.searchPlayerTicket(ticketId, this.checkTicketPin).subscribe(ticket => this.openPlayedTicketDetails(ticket, scanned));
    }
  }

  openPlayedTicketDetails(playedTicket: IPlayedTicket, scanned: boolean){
    if (!playedTicket) {
      this.isSearchValid = false;
      this.searchMessage = DynamicTranslations.findTicket_notFoundMessage;
    } else {
      this.checkTicketId = '';
      this.checkTicketPin = '';
      this.ticketService.openTicketDetails(playedTicket);

      if (scanned) {
        this.googleAnalyticsService.eventEmitter('Provjera listića', 'Skeniranje', playedTicket.id.toString());
      } else {
        this.googleAnalyticsService.eventEmitter('Provjera listića', 'Ručni unos', playedTicket.id.toString());
      }
    }
  }

  scanTicketCompleted(code: string) {
    this.isScanActive = false;
    let ticketCode = '';
    if(isNaN(+code)){
      const index = code.indexOf('ticket=');
      if(index > -1){
        ticketCode = code.slice(index + 7);
      }
    }else{
      ticketCode = code;
    }
    if (isNaN(+ticketCode)) {
      this.checkTicketId = '';
      this.checkTicketPin = '';
    } else {
      this.checkTicketPin = ticketCode.slice(-1 * ConstantValues.TICKET_PIN_SIZE);
      this.checkTicketId = ticketCode.slice(0, -1 * ConstantValues.TICKET_PIN_SIZE).replace(/[^\dA-Z]/g, '').replace(/(.{3})/g, '$1 ').trim();
    }
    this.checkTicket(true);
  }

  public startScanning(): void {
    this.isScanActive = true;
    this.searchMessage = null;
  }

  public stopScaning(): void {
    this.isScanActive = false;
  }

  updateticketItemGroups(cacheChanges: ICacheChanges, isLive) {
    const eventIdsWithChangedOdds: number[] = this.changesUpdater.updateTicketItemGroups(cacheChanges, this.ticketItemGroups, this.languageCulture);
    if (eventIdsWithChangedOdds.length > 0) {
      for (const eventId of eventIdsWithChangedOdds) {
        const eventOdds: IOddContainer = this.ticketService.getMInAndMaxOddForEvent(
          eventId,
          Object.entries(this.ticketItemGroups[eventId].ticketItems).map(([k, ti]) => ({ outcomeId: ti.betOutcomeId, outcomeTypeId: ti.betTypeOutcomeId })),
          this.ticketItemGroups
        );
        this.oddsMap[eventId] = eventOdds.maxOdd;
        this.minOddsMap[eventId] = eventOdds.minOdd;
      }

      if (this.viewConfigurations.showNumberOfHitsForTicketSystem) {
        this.ticketService.minOddsSysEvIdsByOddLowToHighWithoutBankers = this.ticketService.createminOddsSysEvIdsByOddLowToHiWithoutBankers(this.ticketItemGroups, this.eventsInBankersGroup, this.minOddsMap);
        this.ticketService.maxOddsSysEvIdsByOddHighToLowWithoutBankers = this.ticketService.createmaxOddsSysEvIdsByOddHiToLowWithoutBankers(this.ticketItemGroups, this.eventsInBankersGroup, this.oddsMap);
      }
      this.notifyTicketChange(true);
    }
    this.setIsTicketOnline();

    if (this.updatedCacheTime > 10) {
      this.lockStartedEvents();
      this.updatedCacheTime = 0;
    }

    if (isLive) {
      this.updatedCacheTime += ConstantValues.CACHE_INTERVAL_LIVE_SEC;
    } else {
      this.updatedCacheTime += ConstantValues.CACHE_INTERVAL_PM_SEC;
    }
  }

  lockStartedEvents() {
    const dateNow = new Date();
    for (const ordering of this.orderingForTicketItemGroups) {
      if (!this.ticketItemGroups[ordering.eventId].isLive && this.ticketItemGroups[ordering.eventId].eventDateTime <= dateNow) {
        this.ticketItemGroups[ordering.eventId].isEventPlayable = false;
      }
    }
  }

  toggleTicket() {
    this.showTicket = !this.showTicket;
    if (this.showTicket) {
      this.setDialogPosition();
      // this.disableParentScroll();
    } else {
      // this.enableParentScroll();
      this.resetDialogPosition();
    }
    // if (!this.viewConfigurations.showTicketDialogMobileV2) {
    // }

  }

  openMyTickets() {
    this.showTicketDetails = true;

    this.onTiketChange(TicketTab.MyTickets);
    // setTimeout(() => {
    // }, 100);
  }

  get displayFormat(): string {
    return ConstantValues.DISPLAY_NUMBER_FORMAT_STRING_FOR_PIPE;
  }

  setDialogPosition() {
    if (document.getElementById('ticketMainWrap') === null) { return; }
    this.ticketMainWrap = document.getElementById('ticketMainWrap');
    // let scrollTop = environment.localDeploy ? 0 : window.parent.scrollY;
    const scrollTop = 0;
    // const scrollTop = environment.localDeploy ? 0 : window.parent.document.getElementById('container').scrollTop;
    const windowHeight = window.parent.innerHeight;
    const documentHeight = document.body.clientHeight;

    // set max height on dialog
    if (!environment.localDeploy && !this.isMobileView) {
      if (windowHeight < documentHeight) {
        this.ticketMainWrap.style.maxHeight = windowHeight + 'px';
      } else {
        this.ticketMainWrap.style.maxHeight = documentHeight + 'px';
      }
    }

    const move = scrollTop;
    this.ticketMainWrap.style.marginTop = move + 'px';
    this.disableParentScroll();

    // hide mobile ticket bar
    document.getElementById('mobileMenu').classList.add('bottom');
  }

  resetDialogPosition() {
    this.ticketMainWrap.style.maxHeight = '';
    this.enableParentScroll();

    // show mobile ticket bar
    document.getElementById('mobileMenu').classList.remove('bottom');
  }

  disableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'hidden';
  }

  enableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'auto';
  }

  getSportName(sportId: number) {
    return this.utilityService.getSportIcon(sportId);
  }

  validateTicketIdInput() {
    const ticketId = document.getElementById('ticketId');
    const ticketPin = document.getElementById('ticketPin');

    if (ticketId && ticketPin) {
      if (ticketId) {
        ticketId.addEventListener('input', (e) => {
          const target = e.currentTarget as HTMLInputElement;
          target.value = target.value.replace(/\D+/g, '').replace(/(.{3})/g, '$1 ').trim();

          const maxFormatted = ConstantValues.TICKET_ID_SIZE + Math.floor(ConstantValues.TICKET_ID_SIZE / 3) - (ConstantValues.TICKET_ID_SIZE % 3 === 0 ? 1 : 0);
          if (target.value.length > maxFormatted) {
            target.value = target.value.substring(0, maxFormatted);
          }

          if (target.value.length === maxFormatted) {
            ticketPin.focus();
          }
        });
      }

      if (ticketPin) {
        ticketPin.addEventListener('input', (e) => {
          const target = e.currentTarget as HTMLInputElement;
          target.value = target.value.replace(/\D+/g, '').replace(/(.{5})/g, '$1 ').trim();

          if (target.value.length === 0) {
            ticketId.focus();
          }
        });
      }
    }
  }

  changeOddsValidationMode(oddsValidationMode: OddsValidationMode) {
    this.ticketService.notifyOddsValidationChange(oddsValidationMode);
  }

  ngAfterViewInit() {
    if (!this.isMobileView && this.isUserLoggedIn) {
      setTimeout(() => {
        this.validateTicketIdInput();
      }, 700);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
